import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { useQuery } from 'react-query'
import { getPhases } from 'data/Querys';
import { useUrlFriendlyToParameters, useNavigateTo } from "helpers/urlFriendly";
import Label from 'components/general/Label';
import NotAvailable from 'components/common/NotAvailable';
import { getEventRSC } from 'helpers/rsc';
import { sortDataByFieldDesc } from 'helpers/utils';

export default function SelectorPhaseCombo({ page = "", setState }) {
    const [textCombo, setTextCombo] = useState();
    let params = useUrlFriendlyToParameters();
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    const _event = getEventRSC(params.mirs_rsc);
    const labelSwimOff = Label({ data: "SwimOff" });

    //Copy object in order to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['phasesData', params.mirs_competition, params.mirs_language, _event],
            queryFn: getPhases,
            refetchInterval: 0,
        });

    useEffect(() => {
        const lbl = <Label data={'LabelAllPhases'} />;
        setTextCombo(lbl);
    }, [data, paramsURL["mirs_rsc"]]);




    if (isError) { return <NotAvailable />; }
    if (isLoading) { return (''); }
    if (!data) { return (<div className='container'><NotAvailable /></div>); }


    //PHASES 
    let result = sortDataByFieldDesc(data, "order", false);
    //Show if phase has order
    result = result.filter(item => item.order)

    /*
    let units;
    // swim-off units 
    data.forEach((phase, index) => {
        units = phase?.units?.filter(item => item?.code.endsWith('RR--'));
        if (Array.isArray(units) && units.length > 0) {
            let phaseFilter = data.find(item => item.code === phase.code.substring(0, phase.code.length - 2) + "RR")
            if (!phaseFilter) {
                let h = { ...phase };
                h.order = Number(h.order) - 0.5;
                h.shortDescription = phase.shortDescription + " " + labelSwimOff;
                h.code = phase.code.substring(0, phase.code.length - 2) + "RR";
                if (params.mirs_discipline === 'SWM') { data.push(h); }
            }
        }
    })
*/


    const options = result && result.map((item, index) => {
        return (
            <Dropdown.Item key={"Selector-Phase-" + item.code} eventKey={item.code} >
                {item.shortDescription}
            </Dropdown.Item>
        )
    })



    const handleOnChange = (key => {
        paramsURL["mirs_rsc"] = key
        let path = page
        setParamsUrl(paramsURL);
        setState(key)
        let lbl = data?.find(item => item.code === key)?.shortDescription
        if (lbl === undefined) { lbl = <Label data={'LabelAllPhases'} /> }
        setTextCombo(lbl)
        //setShouldNavigate(true);
    })

    return (
        <Dropdown onSelect={handleOnChange} id="selectorPhase" className={"selectorContainer"} >
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                {textCombo}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item key="" eventKey="" >
                    <Label data={'LabelAllPhases'} />
                </Dropdown.Item>
                {options}
            </Dropdown.Menu>
        </Dropdown>
    );
};



